var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgQuote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 176,
    height: 149,
    viewBox: "0 0 176 149",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-0.00157166 125.729C26.2437 112.8 39.3661 97.6096 39.3661 80.1562C28.1796 78.8633 18.9294 74.2846 11.6151 66.4197C4.30086 58.5549 0.643814 49.4512 0.643814 39.1085C0.643814 28.1193 4.19331 18.854 11.2924 11.3124C18.3916 3.77075 27.3191 0 38.0753 0C50.1223 0 60.5557 4.90198 69.3759 14.7061C78.196 24.5102 82.606 36.415 82.606 50.4208C82.606 92.4384 59.1577 125.298 12.2605 149L-0.00157166 125.729ZM92.619 125.729C119.079 112.8 132.309 97.6096 132.309 80.1562C120.908 78.8633 111.55 74.2846 104.236 66.4197C96.9215 58.5549 93.2644 49.4512 93.2644 39.1085C93.2644 28.1193 96.8677 18.854 104.074 11.3124C111.281 3.77075 120.262 0 131.019 0C143.066 0 153.445 4.90198 162.158 14.7061C170.87 24.5102 175.227 36.415 175.227 50.4208C175.227 92.4384 151.886 125.298 105.204 149L92.619 125.729Z",
    fill: "#333333"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuote);
export default __webpack_public_path__ + "static/media/quote.2418a45a5f42245be08f765dbb80859d.svg";
export { ForwardRef as ReactComponent };